import { render, staticRenderFns } from "./SourcesPanel.vue?vue&type=template&id=560974d6&"
import script from "./SourcesPanel.vue?vue&type=script&lang=js&"
export * from "./SourcesPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports